export class Recurso {
    id: string
    nome: string
    descricao: string
    valor: number
    unidadeMedida: string
    idAssociacao: string
}